import { render } from "./VendorsTable.vue?vue&type=template&id=6edf2bb2"
import script from "./VendorsTable.vue?vue&type=script&lang=js"
export * from "./VendorsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__